// Hero band das paginas internas (Planos / Contato) — titulo grande centralizado
// sobre gradiente claro com linhas de onda sutis (fiel ao Figma).
export function PageHero({ title, testId }) {
  return (
    <section className="relative overflow-hidden mc-grad-hero border-b border-[#f1eefb]" data-testid={testId}>
      <svg className="absolute right-0 top-0 h-full w-1/2 opacity-40" viewBox="0 0 600 300" fill="none" preserveAspectRatio="none" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <path key={i} d={`M0 ${40 + i * 45} Q 200 ${i * 30} 600 ${60 + i * 40}`} stroke="#e6def9" strokeWidth="1.5" fill="none" />
        ))}
      </svg>
      <div className="mc-container relative py-14 md:py-20 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1e1b2e]">{title}</h1>
      </div>
    </section>
  );
}
